export default {"src":"/_next/static/media/wgr.c896c2c0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};